var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-1"},[_c('div',{staticClass:"header-1-content"},[_c('h1',{staticClass:"header-1-title"},[_vm._v(_vm._s(_vm.activeTabTitle))]),(_vm.activeTabSubtitle)?_c('h2',{staticClass:"header-1-subtitle"},[_vm._v(" "+_vm._s(_vm.activeTabSubtitle)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }